<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn color="primary" link to="/cadastro-cotacao-frete">
        <v-icon left>mdi-plus</v-icon>
        Cotação de frete
      </v-btn>
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text label="Busque por uma transportadora ou identificador"
                      style="max-width: 400px"
                      v-model="searchText"
                      :on-search="emitChange"/>
    </v-row>
    <px-line-filter :options="statusOptions" v-model="selectedStatus"
                    :on-select-item="emitChange"/>
  </div>
</template>

<script>
export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
    isComprador: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      searchText: null,
      selectedStatus: null,
      statusOptions: [
        {
          id: 'TODAS',
          description: 'Todas',
          value: null,
        },
        {
          id: 'ABERTAS',
          description: 'Abertas',
          value: ['ABERTA', 'COMPRA'],
        },
        {
          id: 'CANCELADAS',
          description: 'Canceladas',
          value: ['CANCELADA'],
        },
        {
          id: 'FINALIZADAS',
          description: 'Finalizadas',
          value: ['FINALIZADA'],
        },
      ],
    };
  },
  methods: {
    emitChange() {
      this.$emit('change', {
        searchText: this.searchText,
        selectedStatus: this.selectedStatus,
      });
    },
  },
  created() {
    [this.selectedStatus] = this.statusOptions;
  },
};
</script>
